import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import P from '../../../../../components/P';
import OptionsContainer from '../../../components/OptionsContainer';

export default function SubmitClaim(props) {
  const { submitted, signature, handleChange } = props;
  const isReadOnly = submitted;
  return (
    <div>
      <Section>
        <ControlContainer>
          <P>
            <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} />
          </P>
          <ul>
            <li>
              <FormattedMessage {...messages.note1} />
            </li>
            <li>
              <FormattedMessage {...messages.note2} />
            </li>
            <li>
              <FormattedMessage {...messages.note3} />
            </li>
            <li>
              <FormattedMessage {...messages.note4} />
            </li>
            <li>
              <FormattedMessage {...messages.note5} />
            </li>
          </ul>
          <div className={'row'}>
            <div className={'form-group col-md-6 col-sm-9'}>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="signature"
                  checked={signature === true}
                  onChange={handleChange('form.signature')}
                />
                <span>
                  <FormattedMessage {...messages.agree} />
                </span>
              </OptionsContainer>
            </div>
          </div>
          <P>
            <FormattedMessage {...messages.clickSubmitClaim} />
          </P>
          <Section>
            <ControlContainer>
              <P style={{ fontWeight: 'bold' }}>
                <FormattedMessage {...messages.privacyStatement} />
              </P>
              <P style={{ fontStyle: 'italic' }}>
                <FormattedMessage {...messages.privacyStatementMessage} />
              </P>
            </ControlContainer>
          </Section>
        </ControlContainer>
      </Section>
    </div>
  );
}

SubmitClaim.propTypes = {
  submitted: PropTypes.bool,
  signature: PropTypes.bool,
  handleChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step14/components/SubmitClaim/index.js